import { NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  ZipStyleguideCoreModule,
  ZipStyleguideDirectivesModule,
  ZipStyleguideIconsModule,
  ZipStyleguideWebModule,
} from '@zip/ng-styleguide';

@NgModule({
  exports: [
    A11yModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    ZipStyleguideCoreModule,
    ZipStyleguideWebModule,
    ZipStyleguideDirectivesModule,
    ZipStyleguideIconsModule,
  ],
})
export class MaterialModule {}
